var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { align: "center" } }, [
      _c("div", { staticClass: "col-md-3 col-md-offset-5" }, [
        _c("img", {
          staticStyle: { "max-width": "100%", "max-height": "100%" },
          attrs: { src: _vm.imageRelativeUri },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { attrs: { align: "center" } }, [
        _c("h2", [
          _vm._v("Não há filtros "),
          _c("u", [_c("i", [_vm._v(_vm._s(_vm.filter))])]),
          _vm._v(" disponiveis :("),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }